import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Grid from "@mui/material/Grid2";
import {
    Badge,
    Box,
    Button,
    Chip,
    FormHelperText,
    IconButton,
    Paper,
    Popper,
    Typography
} from "@mui/material";
import { mmRfqFormDataSelector } from "../../Redux/MMRfq/Selector";
import { connect, useDispatch } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
    setMmRfqFormData,
    updateMmRfqFormItem
} from "../../Redux/MMRfq/actions";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { useEffect, useState } from "react";
import { fetchDataForDisplayDataInDropDownApi } from "../../Sourcing/Services/Filter/Filter";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Dayjs } from "dayjs";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import PartnerDetailsDrawer from "../../Sourcing/Partner/PartnerDetails/PartnerDetailsDrawer";
import { useLocation } from "react-router-dom";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const SelectVendors = ({ MM_RFQ_FORM_DATA }) => {
    dayjs.extend(customParseFormat);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [filteredRows, setFilteredRows] = React.useState(null);
    const [selectedProcess, setSelectedProcess] = React.useState<any[]>([]);
    const [selectedCertification, setSelectedCertification] = React.useState<
        any[]
    >([]);
    const [selectedMachineAvailable, setSelectedMachineAvailable] = useState<
        any[]
    >([]);
    const [filteredSelectedProcess, setFilteredSelectedProcess] =
        React.useState<any[]>([]);
    const [filteredSelectedCertification, setFilteredSelectedCertification] =
        React.useState<any[]>([]);
    const [
        filteredSelectedMachineAvailable,
        setFilteredSelectedMachineAvailable
    ] = useState<any[]>([]);
    const [filterOptions, setFilterOptions] = useState<{
        [key: string]: { key: string; title: string }[];
    }>({});
    const [dueDate, setDueDate] = useState<Dayjs | null>(
        MM_RFQ_FORM_DATA[0]?.expiryDate
            ? dayjs(MM_RFQ_FORM_DATA[0].expiryDate)
            : null
    );
    const [caDueDate, setCaDueDate] = useState<Dayjs | null>(
        MM_RFQ_FORM_DATA[0]?.expiryDate
            ? dayjs(MM_RFQ_FORM_DATA[0].expiryDate)
            : null
    );

    const [openDrawer, setOpenDrawer] = useState(false);
    const location = useLocation();
    const locationData = location?.state;
    const handleCloseDrawer = () => {
        setOpenDrawer(false);
    };
    const [selectedRow, setSelectedRow] = useState(null);
    const [isApplyFilter, setIsApplyFilter] = useState<Boolean>(false);
    const [removeFilter, setRemoveFilter] = useState<boolean>(false);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    // const [selectOption, setSelectOption] = useState("Common Allocation");
    const partDetails = MM_RFQ_FORM_DATA[0]?.Part_Details || [];

    const [selectOption, setSelectOption] = useState(() => {
        if (partDetails.length === 1) {
            return "Part Wise Allocation";
        }
        return locationData?.from === "addPartnerForMMrfq"
            ? "Part Wise Allocation"
            : "Common Allocation";
    });

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedCertification(filteredSelectedCertification);
        setSelectedMachineAvailable(filteredSelectedMachineAvailable);
        setSelectedProcess(filteredSelectedProcess);
    };
    const handleRemoveFilter = (category: string, item: { title: any }) => {
        if (removeFilter == true) {
            setRemoveFilter(false);
        } else {
            setRemoveFilter(true);
        }
        switch (category) {
            case "process":
                setSelectedProcess((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            case "certification":
                setSelectedCertification((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            case "machine":
                setSelectedMachineAvailable((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            default:
                break;
        }
    };
    const dispatch = useDispatch();
    type Vendor = {
        id: string;
        partnerName: string;
        Partner_ID: string;
        partnerID: string;
    };
    const [selectedVendors, setSelectedVendors] = React.useState<{
        [index: number]: Vendor[];
    }>({});

    const [selectedCommonVendors, setSelectedCommonVendors] = useState<
        Vendor[]
    >([]);

    const handleVendorChange = (index: number, value: Vendor[]) => {
        setSelectedVendors((prev) => ({
            ...prev,
            [index]: value
        }));
        const selectedVendorNames = value.map((v) => v.partnerName);
        const selectedVendorID = value.map((v) => v.Partner_ID);
        const partNumber = MM_RFQ_FORM_DATA[0].Part_Details[index];
        dispatch(
            updateMmRfqFormItem({
                ...partNumber,
                selectedVendors: selectedVendorNames,
                selectedVendorsID: selectedVendorID
            })
        );
    };
    React.useEffect(() => {
        const initialSelected = {};
        MM_RFQ_FORM_DATA[0]?.Part_Details?.forEach((part, index) => {
            if (part.selectedVendors?.length && part.Partner_Lists) {
                const selectedVendorObjects = part.Partner_Lists.filter(
                    (vendor) =>
                        part.selectedVendors.includes(vendor.partnerName)
                );
                initialSelected[index] = selectedVendorObjects;
            }
        });
        setSelectedVendors(initialSelected);

        if (Object.keys(filterOptions).length === 0) {
            {
                locationData?.from !== "EditDueDateOfMMrfq" &&
                    fetchFilterData();
            }
        }
    }, []);
    function extractOptions(apiResponse, keyName: string) {
        const section = apiResponse?.find(
            (item) => Object.keys(item)[0] === keyName
        );
        if (!section || !section[keyName]?.choices) return [];
        return section[keyName].choices.flatMap((item) => {
            // Handle Certificate_Name and Machine_category separately
            if (
                item?.link_name === "Certificate_Name" ||
                item?.link_name === "Machine_category"
            ) {
                return item?.choices
                    ?.filter((element) => element.value && element.value !== 0) // Ensure value is not empty or 0
                    ?.map((element) => ({
                        key: element.key,
                        title: element.value
                    }));
            }
            // Handle other categories
            if (item?.value && item?.value !== 0) {
                return {
                    key: item?.key || item?.link_name,
                    title: item?.value || item?.link_name
                };
            }
            return [];
        });
    }
    const fetchFilterData = async () => {
        try {
            const filterData = await fetchDataForDisplayDataInDropDownApi();
            if (filterData?.status) {
                const apiResponse = filterData?.data;
                const processOptions = extractOptions(
                    apiResponse,
                    "Processes_Offered"
                );
                const certificationOptions = extractOptions(
                    apiResponse,
                    "Certifications"
                );
                const machinesOptions = extractOptions(
                    apiResponse,
                    "List_of_Top_machines"
                );
                const obj = {
                    processOptions,
                    certificationOptions,
                    machinesOptions
                };
                setFilterOptions(obj);
            }
        } catch (error) {
            console.log("errrrrrrrrrrrrrrrrr", error);
        }
    };
    const filterData = (rows, filters) => {
        return rows?.filter((row) => {
            const processArray =
                row["Processes_Offered"]?.flatMap((item) =>
                    item.toLowerCase().split(/\s*,\s*/)
                ) || [];
            const certificationArray =
                row["Certifications"]?.flatMap((item) =>
                    item.toLowerCase().split(/\s*,\s*/)
                ) || [];
            const machineArray =
                row["List_of_Top_machines"]?.flatMap((item) =>
                    item.toLowerCase().split(/\s*,\s*/)
                ) || [];
            const { certification = [], machine = [], process = [] } = filters;
            const processMatch =
                process?.length === 0 ||
                process.some((val) => processArray.includes(val));
            const certificationMatch =
                certification?.length === 0 ||
                certification.some((val) => certificationArray.includes(val));
            const machineMatch =
                machine?.length === 0 ||
                machine.some((val) => machineArray.includes(val));
            return certificationMatch && machineMatch && processMatch;
        });
    };
    const handleApply = async () => {
        setIsApplyFilter(true);
        const filters = {
            process:
                selectedProcess?.map((item) => item?.title.toLowerCase()) || [],
            certification:
                selectedCertification?.map((item) =>
                    item?.title.toLowerCase()
                ) || [],
            machine:
                selectedMachineAvailable?.map((item) =>
                    item?.title.toLowerCase()
                ) || []
        };
        if (selectOption === "Common Allocation") {
            // ✅ Combine all partners from all parts
            const allVendors = Array.from(
                new Map(
                    MM_RFQ_FORM_DATA[0].Part_Details.flatMap(
                        (item) => item.Partner_Lists || []
                    ).map((vendor) => [vendor.Partner_ID, vendor])
                ).values()
            );

            // ✅ Apply filters globally
            const filteredResults = filterData(allVendors, filters);
            setFilteredRows({ common: filteredResults });
        } else {
            const newFilteredRows = {};
            MM_RFQ_FORM_DATA[0].Part_Details.forEach((item, index) => {
                const filteredResults = filterData(
                    item?.Partner_Lists,
                    filters
                );
                newFilteredRows[index] = filteredResults;
            });

            setFilteredRows(newFilteredRows);
        }
        setAnchorEl(null);
        setFilteredSelectedCertification(selectedCertification);
        setFilteredSelectedMachineAvailable(selectedMachineAvailable);
        setFilteredSelectedProcess(selectedProcess);
    };

    function handleClearAllChip() {
        handleApply();
        setSelectedCertification([]);
        setSelectedMachineAvailable([]);
        setSelectedProcess([]);
        setFilteredRows({});
        setIsApplyFilter(false);
        setFilteredSelectedCertification([]);
        setFilteredSelectedMachineAvailable([]);
        setFilteredSelectedProcess([]);
    }
    function handleClearAll() {
        setSelectedCertification([]);
        setSelectedMachineAvailable([]);
        setSelectedProcess([]);
    }

    // useEffect(() => {
    //   const updatedArray = [...MM_RFQ_FORM_DATA];
    //   updatedArray[0] = {
    //     ...updatedArray[0],
    //     expiryDate: dueDate ? dueDate?.format("DD-MMM-YYYY") : null,
    //   };
    //   if (MM_RFQ_FORM_DATA[0]?.expiryDate !== dueDate) {
    //     dispatch(setMmRfqFormData(updatedArray));
    //   }
    // }, [dueDate]);

    useEffect(() => {
        const updatedArray = [...MM_RFQ_FORM_DATA];

        // If Common Allocation, use caDueDate; else use dueDate
        const activeDate =
            selectOption === "Common Allocation" ? caDueDate : dueDate;

        updatedArray[0] = {
            ...updatedArray[0],
            expiryDate: activeDate ? activeDate?.format("DD-MMM-YYYY") : null
        };

        if (MM_RFQ_FORM_DATA[0]?.expiryDate !== activeDate) {
            dispatch(setMmRfqFormData(updatedArray));
        }
    }, [dueDate, caDueDate, selectOption]);

    useEffect(() => {
        handleApply();
        if (
            selectedCertification?.length == 0 &&
            selectedMachineAvailable?.length == 0 &&
            selectedProcess?.length == 0
        ) {
            setIsApplyFilter(false);
        }
    }, [removeFilter]);

    console.log("Selected Common Vendors:", selectedCommonVendors);

    return (
        <>
            {locationData?.from !== "addPartnerForMMrfq" && (
                <>
                    <FormControl>
                        <FormLabel id="demo-row-radio-buttons-group-label">
                            How do you want to float the MMRFQ ?
                        </FormLabel>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={selectOption}
                            // onChange={(e) => setSelectOption(e.target.value)}
                            onChange={(e) => {
                                const mode = e.target.value;
                                setSelectOption(mode);

                                // deep clone form data
                                const updatedFormData = JSON.parse(
                                    JSON.stringify(MM_RFQ_FORM_DATA)
                                );

                                // clear selections when switching modes
                                updatedFormData[0].Part_Details =
                                    updatedFormData[0].Part_Details.map(
                                        (p) => ({
                                            ...p,
                                            selectedVendors: [],
                                            selectedVendorsID: []
                                        })
                                    );
                                //Reset Due date
                                setCaDueDate(null);
                                setDueDate(null);
                                updatedFormData[0].expiryDate = null;
                                //reset filters
                                setSelectedProcess([]);
                                setSelectedCertification([]);
                                setSelectedMachineAvailable([]);
                                setFilteredSelectedProcess([]);
                                setFilteredSelectedCertification([]);
                                setFilteredSelectedMachineAvailable([]);
                                setFilteredRows({});
                                setIsApplyFilter(false);
                                // reset error flag + save allocation mode
                                updatedFormData[0].allocationMode = mode;
                                updatedFormData[0].isNextButtomClicked = false;

                                dispatch(setMmRfqFormData(updatedFormData));

                                // also reset local component states
                                setSelectedCommonVendors([]);
                                setSelectedVendors({});
                            }}

                            // onChange={(e) => {
                            //   const mode = e.target.value;
                            //   setSelectOption(mode);

                            //   // Deep copy to avoid mutations
                            //   const updatedFormData = JSON.parse(
                            //     JSON.stringify(MM_RFQ_FORM_DATA)
                            //   );
                            //   updatedFormData[0] = {
                            //     ...updatedFormData[0],
                            //     allocationMode: mode,
                            //     isNextButtomClicked: false,
                            //   };

                            //   dispatch(setMmRfqFormData(updatedFormData));
                            // }}
                        >
                            {partDetails.length > 1 && (
                                <FormControlLabel
                                    value="Common Allocation"
                                    control={<Radio />}
                                    label="Common Allocation"
                                    onChange={(
                                        e: React.ChangeEvent<HTMLInputElement>
                                    ) => setSelectOption(e.target.value)}
                                />
                            )}
                            <FormControlLabel
                                value="Part Wise Allocation"
                                control={<Radio />}
                                label="Part Wise Allocation"
                                onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                ) => setSelectOption(e.target.value)}
                            />
                        </RadioGroup>
                    </FormControl>

                    <Grid container>
                        <Grid size={{ xs: 6, md: 6 }}>
                            <Typography variant="h6" mt={1}>
                                {selectOption === "Common Allocation"
                                    ? "Select partners "
                                    : "Select partners for all the parts"}
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 6, md: 6 }}>
                            <Grid container>
                                <Grid size={{ xs: 12, md: 12 }}>
                                    <IconButton
                                        onClick={handleClick}
                                        sx={{ float: "right" }}
                                    >
                                        <Badge
                                            badgeContent={
                                                (filteredSelectedCertification !=
                                                    null &&
                                                    filteredSelectedCertification?.length) +
                                                (filteredSelectedProcess !=
                                                    null &&
                                                    filteredSelectedProcess?.length) +
                                                (filteredSelectedMachineAvailable !=
                                                    null &&
                                                    filteredSelectedMachineAvailable?.length)
                                            }
                                            color="primary"
                                        >
                                            {locationData?.from !==
                                                "EditDueDateOfMMrfq" && (
                                                <FilterAltOutlinedIcon />
                                            )}
                                        </Badge>
                                    </IconButton>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12 }}>
                                    {isApplyFilter == true && (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexWrap: "wrap",
                                                gap: 1,
                                                justifyContent: "end"
                                            }}
                                            mb={2}
                                        >
                                            {filteredSelectedProcess?.map(
                                                (item, index) => (
                                                    <Chip
                                                        key={`process-${index}`}
                                                        label={item?.title}
                                                        onDelete={() =>
                                                            handleRemoveFilter(
                                                                "process",
                                                                item
                                                            )
                                                        }
                                                        size="small"
                                                    />
                                                )
                                            )}
                                            {filteredSelectedCertification?.map(
                                                (item, index) => (
                                                    <Chip
                                                        key={`certification-${index}`}
                                                        label={item.title}
                                                        onDelete={() =>
                                                            handleRemoveFilter(
                                                                "certification",
                                                                item
                                                            )
                                                        }
                                                        size="small"
                                                    />
                                                )
                                            )}
                                            {filteredSelectedMachineAvailable?.map(
                                                (item, index) => (
                                                    <Chip
                                                        key={`machine-${index}`}
                                                        label={item?.title}
                                                        onDelete={() =>
                                                            handleRemoveFilter(
                                                                "machine",
                                                                item
                                                            )
                                                        }
                                                        size="small"
                                                    />
                                                )
                                            )}
                                            {/* Clear All Button - Show only when filters exist */}
                                            {filteredSelectedCertification?.length +
                                                filteredSelectedProcess?.length +
                                                filteredSelectedMachineAvailable?.length >
                                                0 && (
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    onClick={handleClearAllChip}
                                                    sx={{
                                                        fontSize:
                                                            ".75rem !important",
                                                        lineHeight: "1",
                                                        borderRadius: "30px"
                                                    }}
                                                >
                                                    CLEAR ALL
                                                </Button>
                                            )}
                                        </Box>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Box>
                        <Popper
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            placement="bottom-start"
                            sx={{ zIndex: 13 }}
                        >
                            <Paper
                                sx={{
                                    p: 2,
                                    width: 350,
                                    boxShadow: 3,
                                    borderRadius: 2
                                }}
                            >
                                <Box
                                    sx={{
                                        fontWeight: "bold",
                                        mb: 2,
                                        display: "flex",
                                        justifyContent: "space-between"
                                    }}
                                >
                                    Filter
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={handleClearAll}
                                    >
                                        CLEAR ALL
                                    </Button>
                                </Box>
                                <Box sx={{ mb: 2 }}>
                                    <Autocomplete
                                        multiple
                                        size="small"
                                        sx={{ marginBottom: "15px" }}
                                        limitTags={2}
                                        value={selectedProcess}
                                        options={[
                                            ...(filterOptions?.processOptions ||
                                                [])
                                        ]?.sort((a, b) =>
                                            a?.title?.localeCompare(b?.title)
                                        )}
                                        getOptionLabel={(option) =>
                                            option?.title || ""
                                        }
                                        onChange={(event, newValue) =>
                                            setSelectedProcess(newValue || [])
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Process"
                                                placeholder="Select Process"
                                            />
                                        )}
                                    />
                                    <Autocomplete
                                        multiple
                                        size="small"
                                        sx={{ marginBottom: "15px" }}
                                        limitTags={2}
                                        value={selectedCertification}
                                        options={[
                                            ...(filterOptions?.certificationOptions ||
                                                [])
                                        ]?.sort((a, b) =>
                                            a?.title?.localeCompare(b?.title)
                                        )}
                                        getOptionLabel={(option) =>
                                            option?.title || ""
                                        }
                                        onChange={(event, newValue) =>
                                            setSelectedCertification(
                                                newValue || []
                                            )
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Certification"
                                                placeholder="Select Certification"
                                            />
                                        )}
                                    />
                                    <Autocomplete
                                        multiple
                                        size="small"
                                        sx={{ marginBottom: "15px" }}
                                        limitTags={2}
                                        value={selectedMachineAvailable}
                                        options={[
                                            ...(filterOptions?.machinesOptions ||
                                                [])
                                        ]?.sort((a, b) =>
                                            a?.title?.localeCompare(b?.title)
                                        )}
                                        getOptionLabel={(option) =>
                                            option?.title || ""
                                        }
                                        onChange={(event, newValue) =>
                                            setSelectedMachineAvailable(
                                                newValue || []
                                            )
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Machines Available"
                                                placeholder="Select Machines Available"
                                            />
                                        )}
                                    />
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        mt: 2
                                    }}
                                >
                                    <Button onClick={handleClose} color="error">
                                        CANCEL
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleApply}
                                    >
                                        APPLY
                                    </Button>
                                </Box>
                            </Paper>
                        </Popper>
                    </Box>

                    {selectOption === "Common Allocation" && (
                        <Box sx={{ flexGrow: 1 }} mt={2}>
                            <Grid container>
                                <Grid size={{ xs: 12, md: 12 }}>
                                    {partDetails?.map((item, index) => (
                                        <>
                                            <Chip
                                                key={index}
                                                label={
                                                    <>
                                                        {item?.Part_Number ||
                                                            `PRT00${index + 1}`}{" "}
                                                        :{" "}
                                                        {item?.Part_Name ||
                                                            "Unnamed Part"}
                                                    </>
                                                }
                                                variant="outlined"
                                                size="small"
                                                sx={{
                                                    marginRight: "5px",
                                                    marginBottom: "5px"
                                                }}
                                            />
                                        </>
                                    ))}
                                    <Grid size={{ xs: 12, md: 6 }} mt={2}>
                                        {/* Single Autocomplete for all partners */}
                                        <Autocomplete<Vendor, true, true, false>
                                            disabled={
                                                locationData?.from ===
                                                "EditDueDateOfMMrfq"
                                            }
                                            multiple
                                            fullWidth
                                            id="vendors-autocomplete-common"
                                            options={(
                                                filteredRows?.common ??
                                                Array.from(
                                                    new Map<string, Vendor>(
                                                        partDetails
                                                            .flatMap(
                                                                (item) =>
                                                                    item?.Partner_Lists ||
                                                                    []
                                                            )
                                                            .map(
                                                                (
                                                                    vendor: Vendor
                                                                ) => [
                                                                    vendor.Partner_ID,
                                                                    vendor
                                                                ]
                                                            ) // use Partner_ID as unique key
                                                    ).values()
                                                )
                                            ).sort((a, b) =>
                                                a?.partnerName?.localeCompare(
                                                    b?.partnerName
                                                )
                                            )}
                                            disableCloseOnSelect
                                            disableClearable
                                            clearIcon={null}
                                            getOptionLabel={(option) =>
                                                option?.partnerName
                                            }
                                            value={selectedCommonVendors}
                                            onChange={(_, value) => {
                                                // ensure unique vendors (no duplicates)
                                                const uniqueVendors: Vendor[] =
                                                    Array.from(
                                                        new Map(
                                                            value.map((v) => [
                                                                v.Partner_ID,
                                                                v
                                                            ])
                                                        ).values()
                                                    );

                                                setSelectedCommonVendors(
                                                    uniqueVendors
                                                );

                                                partDetails.forEach((part) => {
                                                    dispatch(
                                                        updateMmRfqFormItem({
                                                            ...part,
                                                            selectedVendors:
                                                                uniqueVendors.map(
                                                                    (v) =>
                                                                        v.partnerName
                                                                ),
                                                            selectedVendorsID:
                                                                uniqueVendors.map(
                                                                    (v) =>
                                                                        v.Partner_ID
                                                                )
                                                        })
                                                    );
                                                });
                                            }}
                                            renderOption={(
                                                props,
                                                option,
                                                { selected }
                                            ) => (
                                                <li {...props}>
                                                    <Checkbox
                                                        icon={icon}
                                                        checkedIcon={
                                                            checkedIcon
                                                        }
                                                        style={{
                                                            marginRight: 8
                                                        }}
                                                        checked={selected}
                                                    />
                                                    {`${option?.partnerName} (${option?.partnerID})`}
                                                </li>
                                            )}
                                            renderTags={(value, getTagProps) =>
                                                value.map((option, index) => {
                                                    const {
                                                        key,
                                                        onDelete,
                                                        ...tagProps
                                                    } = getTagProps({
                                                        index
                                                    });
                                                    return (
                                                        <Chip
                                                            key={key}
                                                            label={`${option?.partnerName} (${option?.partnerID})`}
                                                            // onClick={() => {
                                                            //   setSelectedRow({ unique_ID: option?.Partner_ID });
                                                            //   setOpenDrawer(true);
                                                            // }}
                                                            onDelete={onDelete}
                                                            {...tagProps}
                                                            clickable
                                                            sx={{ mr: 0.5 }}
                                                        />
                                                    );
                                                })
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Choose Partners"
                                                    placeholder="Choose Partners"
                                                    error={
                                                        selectedCommonVendors.length <
                                                            2 &&
                                                        MM_RFQ_FORM_DATA[0]
                                                            ?.isNextButtomClicked
                                                    }
                                                    helperText={
                                                        selectedCommonVendors.length <
                                                            2 &&
                                                        MM_RFQ_FORM_DATA[0]
                                                            ?.isNextButtomClicked
                                                            ? "Select at least 2 partners"
                                                            : ""
                                                    }
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 4 }} mt={2}>
                                        <LocalizationProvider
                                            dateAdapter={AdapterDayjs}
                                        >
                                            <DatePicker
                                                sx={{ minWidth: "100%" }}
                                                label="Due date"
                                                value={caDueDate}
                                                onChange={(newValue) =>
                                                    setCaDueDate(newValue)
                                                }
                                                minDate={dayjs()}
                                                slotProps={{
                                                    field: {
                                                        readOnly: true
                                                    }
                                                }}
                                                // maxDate={dayjs(
                                                //   MM_RFQ_FORM_DATA[0]?.Rfq_Details?.RFQ_End_Date,
                                                //   "DD-MMM-YYYY",
                                                //   true
                                                // )}
                                            />
                                        </LocalizationProvider>
                                        <Typography
                                            color="warning"
                                            variant="caption"
                                        >
                                            {
                                                MM_RFQ_FORM_DATA[0]?.Rfq_Details
                                                    ?.CURFQ_ID
                                            }{" "}
                                            end date is{" "}
                                            {
                                                MM_RFQ_FORM_DATA[0]?.Rfq_Details
                                                    ?.RFQ_End_Date
                                            }
                                        </Typography>
                                        {!MM_RFQ_FORM_DATA[0]?.expiryDate &&
                                            MM_RFQ_FORM_DATA[0]
                                                ?.isNextButtomClicked && (
                                                <FormHelperText
                                                    error
                                                    sx={{ mt: 1 }}
                                                >
                                                    Rfq End Date is Required
                                                </FormHelperText>
                                            )}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    )}
                </>
            )}

            {selectOption === "Part Wise Allocation" && (
                <Box sx={{ flexGrow: 1 }} mt={2}>
                    {partDetails?.map((item, index) => (
                        <Box key={index} sx={{ mb: 4 }}>
                            <Typography
                                sx={{ fontWeight: "bold" }}
                                variant="body2"
                                mb={1}
                            >
                                {item?.Part_Number || `PRT00${index + 1}`} :{" "}
                                {item?.Part_Name || "Unnamed Part"}{" "}
                            </Typography>
                            <Typography variant="body2">
                                Solutions -{" "}
                                {"(" + item?.Solutions.join(", ") + ")"}
                            </Typography>
                            <Grid container spacing={2} mt={2} mb={2}>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Autocomplete<Vendor, true, true, false>
                                        disabled={
                                            locationData?.from ===
                                            "EditDueDateOfMMrfq"
                                        }
                                        multiple
                                        fullWidth
                                        id={`vendors-autocomplete-${index}`}
                                        options={[
                                            ...(filteredRows?.[index] ??
                                                item?.Partner_Lists ??
                                                [])
                                        ]?.sort((a, b) =>
                                            a?.partnerName?.localeCompare(
                                                b?.partnerName
                                            )
                                        )}
                                        disableCloseOnSelect
                                        disableClearable // <-- add this line
                                        clearIcon={null} // <-- add this line
                                        getOptionLabel={(option) =>
                                            option?.partnerName
                                        }
                                        getOptionDisabled={(option) =>
                                            item?.previousSelectedVendors?.some(
                                                (p) =>
                                                    p?.trim()?.toLowerCase() ===
                                                    option?.partnerName
                                                        ?.trim()
                                                        ?.toLowerCase()
                                            )
                                        }
                                        value={selectedVendors[index] || []}
                                        onChange={(_, value) =>
                                            handleVendorChange(index, value)
                                        }
                                        renderOption={(
                                            props,
                                            option,
                                            { selected }
                                        ) => (
                                            <li {...props}>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {`${option?.partnerName} (${option?.partnerID})`}
                                            </li>
                                        )}
                                        renderTags={(value, getTagProps) =>
                                            value.map((option, index) => {
                                                const {
                                                    key,
                                                    onDelete,
                                                    ...tagProps
                                                } = getTagProps({
                                                    index
                                                });
                                                const isDisabled =
                                                    item?.previousSelectedVendors?.some(
                                                        (p) =>
                                                            p
                                                                ?.trim()
                                                                ?.toLowerCase() ===
                                                            option?.partnerName
                                                                ?.trim()
                                                                ?.toLowerCase()
                                                    );

                                                return (
                                                    <Chip
                                                        key={key}
                                                        label={`${option?.partnerName} (${option?.partnerID})`}
                                                        onClick={
                                                            isDisabled
                                                                ? undefined
                                                                : () => {
                                                                      setSelectedRow(
                                                                          {
                                                                              unique_ID:
                                                                                  option?.Partner_ID
                                                                          }
                                                                      );
                                                                      setOpenDrawer(
                                                                          true
                                                                      );
                                                                  }
                                                        }
                                                        onDelete={
                                                            isDisabled
                                                                ? undefined
                                                                : onDelete
                                                        }
                                                        {...tagProps}
                                                        clickable={!isDisabled}
                                                        sx={{
                                                            cursor: isDisabled
                                                                ? "not-allowed"
                                                                : "pointer",
                                                            mr: 0.5,
                                                            opacity: isDisabled
                                                                ? 0.6
                                                                : 1
                                                        }}
                                                    />
                                                );
                                            })
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Choose Partners"
                                                placeholder="Choose Partners"
                                                error={
                                                    (selectedVendors[index]
                                                        ?.length || 0) < 2 &&
                                                    MM_RFQ_FORM_DATA[0]
                                                        ?.isNextButtomClicked
                                                }
                                                helperText={
                                                    (selectedVendors[index]
                                                        ?.length || 0) < 2 &&
                                                    MM_RFQ_FORM_DATA[0]
                                                        ?.isNextButtomClicked
                                                        ? "Select at least 2 partners"
                                                        : ""
                                                }
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    ))}
                    {locationData?.from != "addPartnerForMMrfq" && (
                        <>
                            <Typography
                                sx={{ fontWeight: "bold" }}
                                variant="body2"
                                mb={1}
                            >
                                Select MMRFQ End Date
                            </Typography>
                            <Grid container spacing={2} mt={2} mb={2}>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                    >
                                        <DatePicker
                                            sx={{ minWidth: "100%" }}
                                            label="Due date"
                                            value={dueDate}
                                            onChange={(newValue) =>
                                                setDueDate(newValue)
                                            }
                                            minDate={dayjs()}
                                            slotProps={{
                                                field: {
                                                    readOnly: true
                                                }
                                            }}
                                            // maxDate={dayjs(
                                            //   MM_RFQ_FORM_DATA[0]?.Rfq_Details?.RFQ_End_Date,
                                            //   "DD-MMM-YYYY",
                                            //   true
                                            // )}
                                        />
                                    </LocalizationProvider>
                                    <Typography
                                        color="warning"
                                        variant="caption"
                                    >
                                        {
                                            MM_RFQ_FORM_DATA[0]?.Rfq_Details
                                                ?.CURFQ_ID
                                        }{" "}
                                        end date is{" "}
                                        {
                                            MM_RFQ_FORM_DATA[0]?.Rfq_Details
                                                ?.RFQ_End_Date
                                        }
                                    </Typography>
                                    {!MM_RFQ_FORM_DATA[0]?.expiryDate &&
                                        MM_RFQ_FORM_DATA[0]
                                            ?.isNextButtomClicked && (
                                            <FormHelperText
                                                error
                                                sx={{ mt: 1 }}
                                            >
                                                Rfq End Date is Required
                                            </FormHelperText>
                                        )}
                                </Grid>
                            </Grid>
                        </>
                    )}

                    {/* <PartnerDetailsDrawer
      open={openDrawer}
      onClose={handleCloseDrawer}
      selectedPartner={selectedRow}
    /> */}
                </Box>
            )}
        </>
    );
};
const mapStateToProps = createStructuredSelector({
    MM_RFQ_FORM_DATA: mmRfqFormDataSelector
});
export default connect(mapStateToProps)(SelectVendors);
